import React from 'react';
import { Card } from './ui/card';
import { Sun, Wifi, Home, MapPin } from 'lucide-react';

export const PropertyOverview = () => {
  const features = [
    {
      icon: Sun,
      title: '24/7 Natural Light & Ocean Air',
      description: 'Floor-to-ceiling dual-pane glass facing East and West ensures abundant natural light throughout the day. Minutes from the beach with advanced climate control and air filtration keeps the property an ideal Oasis in the city.'
    },
    {
      icon: Home,
      title: 'Professional & Family Friendly',
      description: 'Premium oak wood finishes, modern architecture, and minimalist aesthetics create a serene living space suitable for your business trip or family getaway...or both, with work and pleasure. Board games meet dedicated workspace, lounge patio to reading nook.'
    },
    {
      icon: Wifi,
      title: 'Premium & Modern',
      description: '10GB fiber and international conversion power plugs with USB. Modern art, premium linens and towels. This isn\'t your typical "rental" - it has everything you need, blending technology and tranquility.'
    },
    {
      icon: MapPin,
      title: 'Prime Downtown Location',
      description: 'Located on Rua Dom Francisco de Avilez in downtown Cascais, surrounded by the famous yellow streets with some of Europe\'s best eateries, palaces and old-town charm. Minutes from the beach and anywhere you want to be.'
    }
  ];
  
  return (
    <section id="overview" className="py-16 sm:py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Compact Section Header */}
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-display font-semibold text-foreground mb-3">
            Your Modern Portuguese Retreat
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed">
            Experience contemporary living with Scandinavian inspired modern design in one of Portugal's most sought-after coastal towns over 850+ years old. Old meets New in this Urban Oasis, minutes from beaches, palaces, eateries and so much more...
          </p>
        </div>
        
        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card 
                key={index}
                className="p-6 bg-card border-border hover:shadow-lg transition-all duration-300 group cursor-pointer"
              >
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="p-2.5 rounded-tl-lg rounded-br-lg rounded-tr-none rounded-bl-none bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                      <Icon size={24} strokeWidth={1.5} />
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg font-display font-semibold text-foreground mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
        
        {/* Property Stats */}
        <div className="mt-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center p-4 rounded-tl-lg rounded-br-lg rounded-tr-none rounded-bl-none bg-muted/50">
              <div className="text-3xl sm:text-4xl font-display font-bold text-primary mb-1">6</div>
              <div className="text-xs sm:text-sm text-muted-foreground font-medium">Guests</div>
            </div>
            <div className="text-center p-4 rounded-tl-lg rounded-br-lg rounded-tr-none rounded-bl-none bg-muted/50">
              <div className="text-3xl sm:text-4xl font-display font-bold text-primary mb-1">5</div>
              <div className="text-xs sm:text-sm text-muted-foreground font-medium">Min to Beach</div>
            </div>
            <div className="text-center p-4 rounded-tl-lg rounded-br-lg rounded-tr-none rounded-bl-none bg-muted/50">
              <div className="text-3xl sm:text-4xl font-display font-bold text-primary mb-1">10GB</div>
              <div className="text-xs sm:text-sm text-muted-foreground font-medium">Internet Speed</div>
            </div>
            <div className="text-center p-4 rounded-tl-lg rounded-br-lg rounded-tr-none rounded-bl-none bg-muted/50">
              <div className="text-3xl sm:text-4xl font-display font-bold text-primary mb-1">100%</div>
              <div className="text-xs sm:text-sm text-muted-foreground font-medium">Modern</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};